// frontend/src/theme.js

// Change the color name here to change the entire app theme
// Options: orange, blue, red, green, purple, indigo, pink, teal, cyan, emerald, amber, rose
export const THEME_COLOR = 'purple';

// Button styles
export const buttonPrimary = `bg-${THEME_COLOR}-500 text-white hover:bg-${THEME_COLOR}-600`;
export const buttonSecondary = `bg-gray-300 text-gray-700 hover:bg-gray-400`;
export const buttonDanger = `bg-red-500 text-white hover:bg-red-600`;

// Badge styles
export const badgePrimary = `bg-${THEME_COLOR}-100 text-${THEME_COLOR}-700`;
export const badgeSuccess = `bg-green-100 text-green-800`;
export const badgeError = `bg-red-100 text-red-800`;
export const badgeWarning = `bg-yellow-100 text-yellow-800`;
export const badgeInfo = `bg-blue-100 text-blue-800`;

// Navigation styles
export const navActive = `bg-${THEME_COLOR}-500 text-white`;
export const navInactive = `text-gray-600 hover:bg-gray-100`;

// Background styles
export const bgLight = `bg-${THEME_COLOR}-50`;
export const bgPrimary = `bg-${THEME_COLOR}-500`;

// Text styles
export const textPrimary = `text-${THEME_COLOR}-600`;
export const textPrimaryDark = `text-${THEME_COLOR}-700`;

// Border styles
export const borderPrimary = `border-${THEME_COLOR}-500`;

// Focus styles
export const focusRing = `focus:ring-2 focus:ring-${THEME_COLOR}-500`;

// Hover styles
export const hoverBgLight = `hover:bg-${THEME_COLOR}-50`;

// Icon button styles
export const iconButtonPrimary = `text-${THEME_COLOR}-600 hover:text-${THEME_COLOR}-800`;

// SweetAlert2 theme colors
export const swalConfirmColor = THEME_COLOR === 'orange' ? '#f97316' : 
                                 THEME_COLOR === 'blue' ? '#3b82f6' :
                                 THEME_COLOR === 'red' ? '#ef4444' :
                                 THEME_COLOR === 'green' ? '#22c55e' :
                                 THEME_COLOR === 'purple' ? '#a855f7' :
                                 THEME_COLOR === 'indigo' ? '#6366f1' :
                                 THEME_COLOR === 'pink' ? '#ec4899' :
                                 THEME_COLOR === 'teal' ? '#14b8a6' :
                                 THEME_COLOR === 'cyan' ? '#06b6d4' :
                                 THEME_COLOR === 'emerald' ? '#10b981' :
                                 THEME_COLOR === 'amber' ? '#f59e0b' :
                                 THEME_COLOR === 'rose' ? '#f43f5e' :
                                 '#f97316'; // default orange

export const swalCancelColor = '#6b7280'; // gray

// Helper function to get theme classes
export const getThemeClass = (type) => {
  const classes = {
    buttonPrimary,
    buttonSecondary,
    buttonDanger,
    badgePrimary,
    badgeSuccess,
    badgeError,
    badgeWarning,
    badgeInfo,
    navActive,
    navInactive,
    bgLight,
    bgPrimary,
    textPrimary,
    textPrimaryDark,
    borderPrimary,
    focusRing,
    hoverBgLight,
    iconButtonPrimary
  };
  return classes[type] || '';
};
